import { AxiosRequestConfig } from "axios";
import apiServiceCall from "../services/ApiServiceCall";

const token = process.env.REACT_APP_TOKEN as string;

export const getUserData = (documentNumber: string) => {
  return apiServiceCall()
    .get(`/pending/info?document=${documentNumber}`, {
      headers: {
        "x-token": token,
      },
    })
    .then(({ data }: getUserDataResponse) => data);
};

export const registerPendingPayment = (
  request: registerPendingPaymentRequest
) => {
  return apiServiceCall()
    .post("/payment/create-web", request, {
      headers: {
        "x-token": token,
      },
    })
    .then(({ data }: registerPendingPaymentResponse) => data);
};

export const registerSponsoredPlayer = (
  request: registerSponsoredPlayerRequest
) => {
  return apiServiceCall()
    .post("/payment/sponsor", request, {
      headers: {
        "x-token": token,
      },
    })
    .then(({ data }: registerPendingPaymentResponse) => data);
};

export const uploadFormDocuments = (
  document: FormData,
  uploadConfig: AxiosRequestConfig
) => {
  return apiServiceCall(true)
    .post("/payment/voucher", document, uploadConfig)
    .then(({ data }: uploadFormDocumentsResponse) => data);
};

interface uploadFormDocumentsResponse {
  data: {
    ok: boolean;
  };
}

interface registerSponsoredPlayerRequest {
  document: string;
  code: string;
}

interface getUserDataResponse {
  data: {
    celphone: string;
    document: string;
    email: string;
    firstname: string;
    id: number;
    id_tipo: number;
    lastname: string;
    paid: number;
    phone: string;
    sponsor: string | null;
    status: number;
    tipo_documento: number;
  };
}

interface registerPendingPaymentRequest {
  document: string;
}

interface registerPendingPaymentResponse {
  data: {
    ok: boolean;
    payment: {
      session: string;
      url: string;
    };
  };
}
